import styled from 'styled-components';

import DefaultLayout from 'src/layouts/default';
import HomeNav from 'src/pages/home/homeNav';

const Container = styled.div`
  display: flex;
  margin-bottom: 120px;
  @media (${({theme}) => theme.underScreenMedium}) {
    margin-bottom: 60px;
  }
  @media (${({theme}) => theme.underScreenSmall}) {
    flex-direction: column;
  }
`;
const Sidebar = styled.div`
  width: 25%;
  padding-right: 10px;
  @media (${({theme}) => theme.underScreenMedium}) {
    width: 33%;
  }
  @media (${({theme}) => theme.underScreenSmall}) {
    width: auto;
    padding: 0;
  }
`;
const Main = styled.div`
  width: 75%;
  padding-left: 10px;
  @media (${({theme}) => theme.underScreenMedium}) {
    width: 67%;
  }
  @media (${({theme}) => theme.underScreenSmall}) {
    width: auto;
    padding: 15px;
  }
`;
const HomeLayout = ({children}: {children: any}) => (
  <DefaultLayout>
    <Container>
      <Sidebar>
        <HomeNav/>
      </Sidebar>
      <Main>
        {children}
      </Main>
    </Container>
  </DefaultLayout>
);

export default HomeLayout;
